import React from "react";
import { useUserPermission } from "utils/hooks/useUserPermission";
import DashboardMember from "../components/dashboard/DashboardMember";
import DashboardAdmin from "components/dashboard/DashboardAdmin";

export default function Dashboard() {

	const { isSuperAdmin } = useUserPermission();
	if (!isSuperAdmin) {
		return <DashboardMember />;
	}

	return <DashboardAdmin />;
}
